var _rect, _path, _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPendienteEntrega(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#F4813F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3182 17.75H27.6364V13H10.4545C9.09841 13 8 14.0628 8 15.375V28.4375H10.4545C10.4545 30.4028 12.1052 32 14.1364 32C16.1675 32 17.8182 30.4028 17.8182 28.4375H25.1818C25.1818 30.4028 26.8325 32 28.8636 32C30.8948 32 32.5455 30.4028 32.5455 28.4375H35V22.5L31.3182 17.75ZM14.1364 30.2188C13.1177 30.2188 12.2955 29.4231 12.2955 28.4375C12.2955 27.4519 13.1177 26.6562 14.1364 26.6562C15.155 26.6562 15.9773 27.4519 15.9773 28.4375C15.9773 29.4231 15.155 30.2188 14.1364 30.2188ZM30.7045 19.5312L33.1161 22.5H27.6364V19.5312H30.7045ZM28.8636 30.2188C27.845 30.2188 27.0227 29.4231 27.0227 28.4375C27.0227 27.4519 27.845 26.6562 28.8636 26.6562C29.8823 26.6562 30.7045 27.4519 30.7045 28.4375C30.7045 29.4231 29.8823 30.2188 28.8636 30.2188Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 13,
    r: 7,
    fill: "#F4813F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19C7.7 19 5 16.3 5 13C5 9.7 7.7 7 11 7C14.3 7 17 9.7 17 13C17 16.3 14.3 19 11 19ZM11 8.2C8.36 8.2 6.2 10.36 6.2 13C6.2 15.64 8.36 17.8 11 17.8C13.64 17.8 15.8 15.64 15.8 13C15.8 10.36 13.64 8.2 11 8.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.28 14.2L10.88 13.6C10.58 13.54 10.4 13.3 10.4 13V10C10.4 9.64002 10.64 9.40002 11 9.40002C11.36 9.40002 11.6 9.64002 11.6 10V12.52L13.52 13C13.82 13.06 14.06 13.42 13.94 13.72C13.88 14.08 13.58 14.26 13.28 14.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPendienteEntrega);
export default __webpack_public_path__ + "static/media/iconPendienteEntrega.5fdffd6a90bd8dfec72001a5823ea65a.svg";
export { ForwardRef as ReactComponent };